export { BackgroundImgUrlModule } from './background-img-url.module';
